import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/shadcn-ui/card';
import { Button } from '@/components/shadcn-ui/button';
import { ArrowRight, Building2, Sparkles } from 'lucide-react';

const AutomationHome = () => {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-3xl font-bold tracking-tight">Automation Engine</h2>
        <p className="text-muted-foreground">
          Manage automation entities and author AHJ profiles from a single place.
        </p>
      </div>

      {/* <div className="grid gap-4 md:grid-cols-2">
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Building2 className="h-5 w-5" />
              AHJs
            </CardTitle>
            <CardDescription>
              Master list of jurisdictions with authoring-ready profile actions.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Button asChild>
              <Link to="/admin/automation/ahjs">
                Open AHJs
                <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
          </CardContent>
        </Card>

        <Card className="border-dashed">
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Sparkles className="h-5 w-5" />
              More Modules
            </CardTitle>
            <CardDescription>
              Additional automation modules can be introduced in this workspace over time.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">Start with AHJs from the sidebar.</p>
          </CardContent>
        </Card>
      </div> */}
    </div>
  );
};

export default AutomationHome;
